import _styled from "styled-components";
import * as React from 'react';
import { useModal } from '@restworld/utils-common';
import { Button, BaseModal } from '../../../'; // eslint-disable-next-line @typescript-eslint/no-empty-interface

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ListModal = function ListModal(_ref) {
  var children = _ref.children,
      isShowMoreButtonVisible = _ref.isShowMoreButtonVisible,
      modalEl = _ref.modalEl;

  var _useModal = useModal(),
      show = _useModal.show,
      close = _useModal.close,
      open = _useModal.open;

  return modalEl ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, isShowMoreButtonVisible && /*#__PURE__*/_jsx(BaseModal, {
      open: show,
      onClose: close,
      showMobileGestures: true,
      children: /*#__PURE__*/_jsx(Wrapper, {
        children: modalEl
      })
    }), isShowMoreButtonVisible && /*#__PURE__*/_jsx(Button, {
      onClick: open,
      title: "Mostra di pi\xF9",
      variant: "ghost",
      icon: "PlusSmallIcon",
      isUnderLined: true,
      fontColor: "black"
    })]
  }) : null;
};
export default ListModal;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modallist__Wrapper",
  componentId: "sc-1350ulp-0"
})({
  "paddingBottom": "0.75rem"
});